import React from "react";
import "./section.scss";

function BanerTitle() {
  return (
    <div className="section__baner">
      <p className="section__baner_p">
        <span className="section__baner_span">THE ART OF FOOD</span>
      </p>
    </div>
  );
}

export default BanerTitle;
